import { render, staticRenderFns } from "./phoneReRegister.vue?vue&type=template&id=1acc8950&scoped=true"
import script from "./phoneReRegister.vue?vue&type=script&lang=js"
export * from "./phoneReRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acc8950",
  null
  
)

export default component.exports